export const dummyRecentActivity = [
  {
    id: 1,
    label: "Organization Added",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
    date: "17 Nov 2024",
  },
  {
    id: 2,
    label: "Organization Edited",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
    date: "17 Nov 2024",
  },
  {
    id: 3,
    label: "Organization Deleted",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
    date: "17 Nov 2024",
  },
  {
    id: 4,
    label: "Organization Edited",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
    date: "17 Nov 2024",
  },
  {
    id: 5,
    label: "Organization Added",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
    date: "17 Nov 2024",
  },
];
